export const ListaStati = {
    0: {
        status: 0,
        label: "Headquarter"
    },
    1: {
        status: 2,
        label: "Leave"
    },
    2: {
        status: 1,
        label: "Bank Holiday"
    },
    3: {
        status: 3,
        label: "Italy"
    },
    4: {
        status: 4,
        label: "Mission"
    }
};
export const legendaStati = [ //vedi filter per ogni modifica
    "Headquarter",
    "Bank Holiday"
];
export let leaveLabel = [
    "Holiday",
    "Sickness"
];
export const usersEndpointRoot = '/users';
export const usersEndpoint = {
    'manager': '/manager',
    'areamanager': '/am',
    'areamanager_manager': '/am_manager',
    'ad': '/ad',
    'hr': '/hr',
    'secretary': '/delegate',
    'readonly': '/readonly'
};
export const secretaryDelegation = '/users/delegations';
export const leaveDetailList = '/users/canSeeLeaveDetails';
export const userGroup = {
    "am": 1,
    "manager": 2,
    "am_manager": 2,
    "ad": null,
    "delegate": null, //segretaria
    "hr": null
}
export const TIMEOUT: number = 1000;
export const RETRY_ATTEMPS: number = 5;
export const urlOVS: string = 'https://weekplanning.gcp.ovs.it/api';
export const urlOVSAndroid: string = 'https://weekplanning.gcp.ovs.it/api';
export const apiUrls = {
    login: '/login',
    confirm_week: '/confirm_week',
    week_lock: '/unlock_week',
    autocompletion_loc: '/v2/autocomplete_places_stores',
    search_autocomplete: '/search_autocomplete',
    search_generic: '/search_generic',
    save_slots: '/save_slots'
}


// WEBPACK FOOTER //
// ./src/constants/constants.ts